export const transaction_detail = {
  /** Browser tab title (set by the Async component via useAsyncPageDocumentTitle). */
  documentTitle: "Transaction",
  title: "Transaction",
  back_to_transactions: "Back to transactions",
  add_allocation_heading: "Add allocation",
  add_allocation: "Add allocation",
  add_error: "Could not create allocation",
};
